<div class="content">
    <h4>Atualização de Anúncios</h4>
    <div class="text-content">
        <textarea #inp  style="resize: none;" [(ngModel)]="texto"> </textarea>
    </div>
    <div class="pb-content">
        <mat-progress-bar
        class="example-margin"
        color="primary"
        mode="determinate"
        [value]="value">
    </mat-progress-bar>
    </div>
    <div class="button-content">
        <div fxFlex></div>
        <span><button mat-raised-button color="primary" (click)="sair()" [disabled]="disabled">Sair</button></span>
    </div>
</div>